import { notifications } from '@mantine/notifications'
import { useQueryClient } from '@tanstack/react-query'

import type { AddGoalProps } from '@/modules/actionPlan/pages/components/AddGoal/AddGoal.types'
import { GoalForm } from '@/modules/actionPlan/pages/components/GoalForm/GoalForm'
import type { GoalFormSchema } from '@/modules/actionPlan/pages/components/GoalForm/GoalForm.types'
import { goalFormDefaultValues } from '@/modules/actionPlan/pages/components/GoalForm/GoalForm.values'

import {
  useGoalsServiceGoalsControllerAdd,
  useGoalsServiceGoalsControllerGetAllKey,
} from '@/__generated__/queries'

import { INSIGHTS_QUERY_KEY } from '@/hooks/useInsightsQuery.hook'

export function AddGoal({ onClose }: AddGoalProps) {
  const queryClient = useQueryClient()

  const initialValues = goalFormDefaultValues()

  const createGoalMutation = useGoalsServiceGoalsControllerAdd({
    onSuccess: () => {
      notifications.show({
        color: 'green',
        message: 'Goal created successfully',
        title: 'Goal created',
      })

      queryClient.invalidateQueries({
        queryKey: [useGoalsServiceGoalsControllerGetAllKey],
      })
      queryClient.invalidateQueries({
        queryKey: [INSIGHTS_QUERY_KEY],
      })

      onClose()
    },
  })

  const handleSubmit = (values: GoalFormSchema) => {
    createGoalMutation.mutate({
      requestBody: values,
    })
  }

  return (
    <GoalForm data={initialValues} onClose={onClose} onSubmit={handleSubmit} />
  )
}
